module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAElJREFUSA1jfPny5X8GEoC4uDgjCcoZmEhRTI7aUQsIhtpoEI0GEcEQIKiA5qmIpHIF5FxSyy6a+2DUgoFPRaNxMBoHBEOAoAIAYC0H6XnXoUwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pattern-transparent--light.png
// module id = 1308
// module chunks = 1